import { render, staticRenderFns } from "./HousekeepingDialog.vue?vue&type=template&id=3af95428&scoped=true"
import script from "./HousekeepingDialog.vue?vue&type=script&lang=js"
export * from "./HousekeepingDialog.vue?vue&type=script&lang=js"
import style0 from "./HousekeepingDialog.vue?vue&type=style&index=0&id=3af95428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af95428",
  null
  
)

export default component.exports